export function confirmarDuasVezes(opts: {
  primeiraMensagem: string;
  segundaMensagem?: string;
}): boolean {
  if (!window.confirm(opts.primeiraMensagem)) return false;
  const segunda = opts.segundaMensagem || "Tem certeza ABSOLUTA? Esta ação é IRREVERSÍVEL.";
  return window.confirm(segunda);
}
